<template>
  <div class="page-wrapper" id="app">
    <v-app id="noisypeak">
    <router-view name="headerMobile"/>
    <router-view name="header"/>

    <router-view name="sidebar"/>

    <div :class="{'page-container': !$route.meta.onlyGuestUser}">
      <router-view></router-view>
    </div>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>
